export default {
  orderList: {
    refresh: 'orderList:refresh'
  },
  stockOrderList: {
    refresh: 'stockOrderList:refresh'
  }
}
